import { createSlice } from "@reduxjs/toolkit";

const tagInputSlice = createSlice({
  name: "tagInput",
  initialState: {},
  reducers: {
    addTag: (state, action) => {
      const { key, tag } = action.payload;
      if (!state[key]) state[key] = { tags: [], error: "", isError: false };

      if (!tag || state[key].tags.includes(tag)) {
        state[key].error = "Empty or duplicate tag not allowed";
        state[key].isError = true;
      } else {
        state[key].tags.push(tag);
        state[key].error = "";
        state[key].isError = false;
      }
    },
    removeTag: (state, action) => {
      const { key, index } = action.payload;
      state[key].tags.splice(index, 1);
    },
    validateTags: (state, action) => {
      const { key } = action.payload;

      if (!state[key]) {
        // Initialize if not present
        state[key] = {
          tags: [],
          error: "Minimum 3 tags required",
          isError: true,
        };
      } else if (state[key].tags.length < 3) {
        state[key].error = "Minimum 3 tags required";
        state[key].isError = true;
      } else {
        state[key].error = "";
        state[key].isError = false;
      }
    },
    resetTags: (state, action) => {
      const { key } = action.payload;
      state[key] = { tags: [], error: "", isError: false };
    },
  },
});

export const { addTag, removeTag, validateTags, resetTags } =
  tagInputSlice.actions;
export default tagInputSlice.reducer;
